// extracted by mini-css-extract-plugin
export default {"alert":"alert__LkRv1","success":"success__cVatA","error":"error__U+47Q"};